import { CloseIcon } from '../../icons/CloseIcon';
import {
  Content,
  Copy,
  CtaSlot,
  DismissButton,
  Subtitle,
  Text,
  Title,
  ToneBar,
  Wrapper,
} from './Dialog.styles';
import type { DialogProps, DialogTone } from './Dialog.types';

const ALERT_TONES: DialogTone[] = ['warning', 'danger'];

export function Dialog({
  tone,
  title,
  subtitle,
  cta,
  onDismiss,
  dismissLabel = 'Dismiss',
  className,
}: DialogProps) {
  return (
    <Wrapper className={className} role={ALERT_TONES.includes(tone) ? 'alert' : 'status'}>
      <Content>
        <Copy>
          <ToneBar data-tone={tone} aria-hidden="true" />
          <Text>
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </Text>
        </Copy>

        {cta && <CtaSlot>{cta}</CtaSlot>}
      </Content>

      {onDismiss && (
        <DismissButton
          type="button"
          onClick={onDismiss}
          aria-label={dismissLabel}
          data-dialog-dismiss
        >
          <CloseIcon size={10} />
        </DismissButton>
      )}
    </Wrapper>
  );
}
